export const STATUS = {
  ok: { label: "OK", pill: "bg-emerald-50 text-emerald-700 ring-emerald-200", bar: "bg-emerald-500" },
  expiring: { label: "Wygasa", pill: "bg-amber-50 text-amber-800 ring-amber-200", bar: "bg-amber-500" },
  expired: { label: "Wygasło", pill: "bg-red-50 text-red-700 ring-red-200", bar: "bg-red-500" },
  missing: { label: "Brak", pill: "bg-zinc-900 text-white ring-zinc-900", bar: "bg-zinc-900" },
  missing_date: { label: "Brak daty", pill: "bg-amber-50 text-amber-800 ring-amber-200", bar: "bg-amber-500" },
  not_required: { label: "Niewymagane", pill: "bg-zinc-100 text-zinc-500 ring-zinc-200", bar: "bg-zinc-300" },
};

export const EMPLOYMENT = {
  uop: { label: "Umowa o pracę", short: "UoP" },
  uz: { label: "Umowa zlecenie", short: "UZ" },
  b2b: { label: "B2B", short: "B2B" },
  none: { label: "Brak umowy", short: "—" },
};

export const URGENCY = [
  { key: 0, label: "Pilne", desc: "wygasłe / brak umowy", tone: "text-red-700 bg-red-50 ring-red-200" },
  { key: 1, label: "Wkrótce", desc: "kończy się w ciągu 30 dni", tone: "text-amber-800 bg-amber-50 ring-amber-200" },
  { key: 2, label: "Rachunki", desc: "brakujące rachunki miesięczne", tone: "text-indigo-800 bg-indigo-50 ring-indigo-200" },
  { key: 3, label: "Braki w teczce", desc: "dokumenty do zebrania", tone: "text-zinc-800 bg-zinc-100 ring-zinc-200" },
];

export const fmtDate = (iso) => (iso ? new Date(`${String(iso).slice(0, 10)}T12:00:00`).toLocaleDateString("pl-PL", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");

export const fmtMoney = (n) => `${Number(n || 0).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} zł`;

export const initials = (first = "", last = "") => `${first[0] || ""}${last[0] || ""}`.toUpperCase() || "?";

export const healthTone = (h) => (h >= 90 ? "bg-emerald-500" : h >= 60 ? "bg-amber-500" : "bg-red-500");
